import { map, compact, find, some, filter, isArray, includes } from "lodash";
import conventionManager from "../../managers/conventionManager";
import { privateDico } from "src/assets/dico/privateDico";

class CompactInfoTableOfContentsManager {
    getAnnotationItems(convention) {
        const allSectionsItems = this.getAllSectionsItems(convention);
        const { annotationsByTitlePath } = convention;
        return this.filteredAnnotationItems(allSectionsItems, Object.keys(annotationsByTitlePath));
    }

    filteredAnnotationItems(allSectionsItems, annotationsTitlePathKeys, titlePath = "") {
        return allSectionsItems
            .map(sectionItem => {
                const shouldKeepTitle = some(annotationsTitlePathKeys, key =>
                    includes(key.split("/"), sectionItem.key)
                );
                const annotationPath =
                    titlePath === "" ? sectionItem.key : `${titlePath}/${sectionItem.key}`;
                return shouldKeepTitle
                    ? {
                          ...sectionItem,
                          key: annotationPath,
                          children: this.filteredAnnotationItems(
                              sectionItem.children,
                              annotationsTitlePathKeys,
                              annotationPath
                          ),
                      }
                    : null;
            })
            .filter(i => i !== null);
    }

    getAllSectionsItems(convention) {
        const { sections, sectionsDraft } = convention;
        const themes = privateDico.convention.themes;
        return map(themes, (theme, sectionName) => {
            const section = find(sections, s => s.key === sectionName);
            if (section) {
                const [, titleContent] = this.splitTitleAndKey(section.title);
                const item = {
                    key: section.key,
                    type: section.type,
                    title: titleContent,
                    children: [],
                    class: "full",
                    legend: "",
                    level: 1,
                };
                if (isArray(section.children) && section.children.length > 0) {
                    return { ...item, children: this._getAllSectionsItems(section.children, item) };
                }
                return item;
            } else {
                const isDraft = some(sectionsDraft || [], name => name === sectionName);
                const isParentEnveloppe = conventionManager.isParentEnveloppe(convention);
                const newItem = {
                    key: theme._uid,
                    title: theme,
                    level: 1,
                    children: [],
                    class: "empty",
                };
                if (isDraft) {
                    return { ...newItem, legend: "Prochainement en ligne" };
                }
                if (isParentEnveloppe) {
                    return { ...newItem, legend: "Pas de dispositions communes" };
                }
                return { ...newItem, legend: "Pas de dispositions" };
            }
        });
    }

    _getAllSectionsItems(sections, parentItem) {
        return compact(
            filter(sections, section => section.type !== "note-di").map(section => {
                const [, titleContent] = this.splitTitleAndKey(section.title);
                const title = document.getElementById(section.key);
                const level = parentItem ? parentItem.level + 1 : 1;
                if (title?.style.display === "none" && level > 1) {
                    return null;
                }
                const newItem = {
                    key: section.key,
                    title: titleContent,
                    level: level,
                    type: section.type,
                    children: [],
                    legend: "",
                };
                if (isArray(section.children) && section.children.length > 0 && level < 4) {
                    newItem.children = this._getAllSectionsItems(section.children, newItem);
                }
                return newItem;
            })
        );
    }

    splitTitleAndKey(title) {
        if (title.indexOf("|") > -1) {
            return [title.split("|")[0].trim(), title.split("|")[1].trim()];
        }
        return ["", title];
    }
}

const compactInfoTableOfContentsManager = new CompactInfoTableOfContentsManager();
export default compactInfoTableOfContentsManager;
